import React from "react";
import { FiCopy } from "react-icons/fi";
import { highlightText } from "../helpers/Helper";

const CollapsibleJson = ({ data, highlightTerm, onCopy }) => {
  const formattedJson = JSON.stringify(data, null, 2);
  const highlightedJson = highlightTerm
    ? highlightText(formattedJson, highlightTerm)
    : formattedJson;

  return (
    <pre className="json-data" style={{ position: 'relative' }}>
      {onCopy ? (
        <button
          type="button"
          aria-label="Copy JSON to clipboard"
          title="Copy to clipboard"
          onClick={onCopy}
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            background: 'none',
            color: 'inherit',
            border: 'none',
            padding: 4,
            cursor: 'pointer',
          }}
        >
          <FiCopy size={18} />
        </button>
      ) : null}
      <code dangerouslySetInnerHTML={{ __html: highlightedJson }}></code>
    </pre>
  );
};

export default CollapsibleJson;
